import { render } from "./SelectedListTemplate.vue?vue&type=template&id=dc6f4504&scoped=true"
import script from "./SelectedListTemplate.vue?vue&type=script&lang=js"
export * from "./SelectedListTemplate.vue?vue&type=script&lang=js"

import "./SelectedListTemplate.vue?vue&type=style&index=0&id=dc6f4504&scoped=true&lang=css"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6f4504"]])

export default __exports__